import(/* webpackMode: "eager" */ "C:\\DC\\projects\\2406mem\\components\\common\\globals\\NavigationMenuInner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\common\\InnerBanner.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\DC\\projects\\2406mem\\components\\details\\VersityList.jsx");
